import {
    SET_ORDER_SETTINGS_DATA_LOADING,
    SET_ORDER_SETTINGS_DATA,
    CLEAR_ORDER_SETTINGS_DATA,
} from "../actions/types";

const initialState = {
    isLoading: false,
    orderSettingsData: [],
};

export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case SET_ORDER_SETTINGS_DATA_LOADING:
            return {
                ...state,
                isLoading: payload,
            };
        case SET_ORDER_SETTINGS_DATA:
            return {
                ...state,
                orderSettingsData: Array.isArray(payload) ? [...payload] : [],
                isLoading: false,
            };
        default:
            return state;
    }
}
